var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default (function (props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 32 38' }, props),
    React.createElement('path', { d: 'M34.272 27.424v2.304h-36.544v-27.456h2.272v25.152h34.272zM2.848 22.752l-1.344-1.568 8.288-7.072 1.344 1.6-8.288 7.040zM2.848 14.112l-1.344-1.568 8.288-7.040 1.344 1.568-8.288 7.040zM8.224 15.424l1.6-1.312 6.624 8.128-1.6 1.312-6.624-8.128zM8.224 6.784l1.6-1.312 14.144 17.376-1.6 1.312-14.144-17.376zM14.848 23.552l-1.344-1.6 18.336-15.264 1.344 1.6-18.336 15.264zM22.368 24.128l-1.344-1.6 10.72-8.896 1.312 1.568-10.688 8.928z' })
  );
});